define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.VisitMonitoring = function () {
        this.applicationType = "AgentVisitMonitoring";
//    var logger = lpTag.WebAgent.WebAgentLogger.getLogger(this.applicationType);

        var visitManagerResources = agentLEManager.getLEUrlResolverApiResourcesService("Smt");
        var visitMonitoringApiResource;

        if (visitManagerResources && visitManagerResources[this.applicationType] && visitManagerResources[this.applicationType].url) {
            var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(visitManagerResources[this.applicationType].url);
            var resourceDomainUrl = lpUtils.getSubDomain(fullResourceUrl);
            var additionalUrl = fullResourceUrl.substring(resourceDomainUrl.length);
            visitMonitoringApiResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: this.applicationType});
        }

        function _createRequest(reqObj, visitorId, sid) {
            reqObj.method = 'GET';
            reqObj.additionalUrl = additionalUrl.replace("{visitorId}", visitorId + "") + "&sid=" + encodeURIComponent(sid);
            reqObj.callingFunction = 'getVisitorData';
            return reqObj;
        }

        this.getRequest = function (reqObj, visitorId, sid) {
            reqObj = _createRequest(reqObj, visitorId, sid);
            var fullRequest = visitMonitoringApiResource.createBasicRequest(reqObj);
            fullRequest.polling = true;
            return fullRequest;
        };

        this.getVisitorData = function (reqObj, visitorId, sid) {
            reqObj = _createRequest(reqObj, visitorId, sid);
            visitMonitoringApiResource.sendRequest(reqObj);
        };
    };

    return lpTag.VisitMonitoring;

});
